import React, { SyntheticEvent } from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { messengerIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useShareContext } from '../../context/ShareContext';
import SOCIAL from '../../constants/social';
import isMobile from '../../utils/isMobile';
import { captureException } from '@sentry/browser';

interface MessengerShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const MessengerShareRound: React.FunctionComponent<MessengerShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { shareItems } = useShareContext();

  const linkItemClick = (event: SyntheticEvent) => {
    onClick();

    if (!isMobile(window)) {
      event.preventDefault();
      FB.ui(
        {
          method: 'send',
          link: shareItems.facebookMessenger.url,
        },
        response => {
          if (response.error_message || response.error_code) {
            captureException({
              facebookErrorCode: response.error_code,
              facebookErrorMessage: response.error_message,
            });
          }
        },
      );
    }
  };

  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a
        href={`fb-messenger://share/?link=${encodeURIComponent(
          shareItems.facebookMessenger.url,
        )}&app_id=${SOCIAL.FB_APP_ID}`}
        data-qa="messenger-btn"
        onClick={linkItemClick}
      >
        <div className={classNames(styles.iconWrapper, styles.messenger)}>
          <Svg markup={messengerIcon} className={styles.icon} />
        </div>
        Messenger
      </a>
    </IconButton>
  );
};
